import { CaseNoteResponse, ClientDetailResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useCaseNoteLabel } from "@/common/hooks/useCaseNoteLabel";
import { useTranslation } from "@/translations";

import { AssignmentFormFields } from "../shared/AssignmentFormFields";
import { useAssignmentCreation } from "./hooks/useAssignmentCreation";

export const TASK_CREATE_DIALOG_ARIA = "assignment-create-dialog-title";

interface Props {
  onClose: () => void;
  client?: ClientDetailResponse;
  caseNote?: CaseNoteResponse;
}

export function AssignmentCreationDialog({ onClose, client, caseNote }: Props) {
  const { t } = useTranslation();
  const caseNoteLabel = useCaseNoteLabel(caseNote);
  const { formik, priorityOptions } = useAssignmentCreation(
    onClose,
    client?.clientId,
    caseNote?.caseNoteId,
    caseNote ? t("assignments.creationDialog.avAssignmentDefaultDescription") : undefined
  );

  return (
    <FormDialog
      title={t("assignments.creationDialog.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("assignments.creationDialog.submitButton")}
      fullWidth
    >
      <AssignmentFormFields
        formik={formik}
        priorityOptions={priorityOptions}
        clientName={client?.fullName}
        clientReadOnly={!!client}
        caseNoteId={caseNote?.caseNoteId}
        caseNoteLabel={caseNoteLabel || undefined}
      />
    </FormDialog>
  );
}
